import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { StepId, STEPS, getStepTitle } from './constants';

interface Props {
  currentStep: StepId;
  onNext: () => void;
  onPrevious: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
}

export default function Navigation({ 
  currentStep, 
  onNext, 
  onPrevious, 
  isFirstStep, 
  isLastStep 
}: Props) {
  const currentStepIndex = STEPS.findIndex(step => step.id === currentStep);
  const progress = ((currentStepIndex + 1) / STEPS.length) * 100;

  return (
    <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-10">
      {/* Progress bar */}
      <div className="h-1 bg-gray-100">
        <div 
          className="h-full bg-teal-600 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="w-full max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
        <button
          onClick={onPrevious}
          aria-disabled={isFirstStep}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors
            ${isFirstStep
              ? 'text-gray-300 cursor-not-allowed pointer-events-none'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }
          `}
        >
          <ArrowLeft className="h-4 w-4" />
          Previous
        </button>

        <div className="text-sm font-medium text-gray-500">
          Step {currentStepIndex + 1} of {STEPS.length}
        </div>

        <button
          onClick={onNext}
          aria-disabled={isLastStep}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors
            ${isLastStep
              ? 'text-gray-300 cursor-not-allowed pointer-events-none'
              : 'bg-teal-600 text-white hover:bg-teal-700'
            }
          `}
        >
          {isLastStep ? 'Complete' : 'Next'}
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}